import './style.modules.scss'

import React from 'react'

import { CardCarousel, CardCarouselProps } from '../CardCarousel/CardCarousel'
import { CardGrid, CardGridProps } from '../CardGrid/CardGrid'
import { CardList, CardListProps } from '../CardList/CardList'

export type CardCollectionProps = (
  | CardGridProps
  | CardListProps
  | CardCarouselProps
) & { template: string }

export const CardCollection = (props: CardCollectionProps) => {
  const { template, cardList, testId, ...rest } = props
  switch (template) {
    case 'card-grid-nextGen':
      return (
        <CardGrid
          {...rest}
          cardList={cardList ?? []}
          testId={testId ?? undefined}
        />
      )
    case 'card-list-nextGen':
      return (
        <CardList
          {...rest}
          cardList={cardList ?? []}
          testId={testId ?? undefined}
        />
      )
    case 'card-carousel-nextGen':
      return (
        <CardCarousel
          {...rest}
          cardList={cardList ?? []}
          testId={testId ?? undefined}
        />
      )
    case 'card-carousel-nextgen-related-info':
      return (
        <CardCarousel
          {...rest}
          cardList={cardList ?? []}
          testId={testId ?? undefined}
          isRelatedInfo={true}
        />
      )
    default:
      return null
  }
}
